import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { FaChartPie } from "react-icons/fa";

const COLORS = ["#1F2B68", "#0284C7", "#10B981", "#D97706", "#DB2777", "#7C3AED"];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0];
    return (
      <div className="sad-custom-tooltip">
        <p className="tooltip-title">{data.name}</p>
        <p style={{ color: data.payload.fill }}>
          Cantidad: <strong>{data.value}</strong> ({data.payload.percent ? `${(data.payload.percent * 100).toFixed(1)}%` : ""})
        </p>
      </div>
    );
  }
  return null;
};

export default function CategoryDistributionChart({ data = [] }) {
  const chartData = data.length > 0 ? data : [
    { name: "Expediente Ciudadano", value: 340 },
    { name: "Expediente Empresarial", value: 180 },
    { name: "Patrimonial Catastral", value: 240 },
    { name: "Certificados Especiales", value: 95 },
  ];

  return (
    <div className="sad-card">
      <div className="sad-card-header">
        <span className="sad-card-title">
          <FaChartPie className="text-primary" /> Desglose por Tipo de Trámite
        </span>
        <span className="sad-card-badge">Distribución</span>
      </div>

      <div className="sad-chart-container">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={55}
              outerRadius={85}
              paddingAngle={4}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: "11px", color: "#475569" }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
